export const NAME = 'sellerRequest-attachments';

export const DOCUMENT_NOT_FOUND_DIALOG = `${NAME}/DOCUMENT_NOT_FOUND_DIALOG`;
